module.exports = __webpack_public_path__ + "img/05.d6713ce8.png";